import React from "react";
import styled from "styled-components";

const HiddenVideo = styled.video`
  z-index: -2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const HiddenImage = styled.img`
  z-index: -2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const HiddenVideoHider = styled.div`
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--color-amber-50);
`;

function HiddenVideoAndImage({ videoRef, imageRef }) {
  return (
    <>
      <HiddenVideo autoPlay muted playsInline ref={videoRef} />
      <HiddenVideoHider />
      <HiddenImage ref={imageRef} />
    </>
  );
}

export default HiddenVideoAndImage;
